module.exports = __webpack_public_path__ + "img/logo.b8973673.png";